import { gql } from "@apollo/client";
import { globalLensFragmentV2 } from "../fragments";

export const getCachedLensListV2 = gql`
    query getCachedLensListV2 {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        getLensListV2(input: { limit: 0, offset: 0, organizationId: null }) {
            lensesWithConnections {
                ...GlobalLensFragmentV2
            }
            cursor
        }
    }
    ${globalLensFragmentV2}
`;
